import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-premium-modal',
  templateUrl: './premium-modal.component.html',
  styleUrls: ['./premium-modal.component.scss'],
})
export class PremiumModalComponent {
  @Output() closeModal = new EventEmitter<void>();

  constructor(private router: Router) {}

  onClose(): void {
    this.closeModal.emit();
  }

  onAssinarPremium(): void {
    this.closeModal.emit();
    window.location.href = `${environment.PORTAL_URL}/selecionar-plano`;
  }

  onVoltar(): void {
    this.closeModal.emit();
  }
}
